import React from "react";

export default function ProgressStepperStep(props) {
    const { title, subtitle, step, info } = props;
    return (
    <div className={`complaint-row-step ${info}`} id={`step-${step}`}>
        <div className={`complaint-row-step-desc ${info}`}>
            <div className="complaint-step-title">
                {title}
            </div>
            <div className="complaint-step-breif">
                {subtitle}
            </div>
        </div>
        <div className="complaint-step-circle">
            {step === "isDone" ? "✔" : step}
        </div>
    </div>
    );
}